/**
 *  Parse a row from an ELIG5 file
 *  ELIG5 files contain patient and caregiver information
 */
const { parseDate, makeDate } = require('../fileDates')

const DEFAULT_MAP = {
  carrier: [0, 9],
  account: [9, 24],
  group: [24, 39],
  memberId: [39, 57],
  addressFlag: [57, 58],
  address1: [58, 118],
  address2: [118, 178],
  address3: [178, 238],
  city: [238, 258],
  state: [258, 260],
  zip1: [260, 265],
  zip2: [265, 269],
  phoneNumber: [269, 279],
  privacyTypeCode: [279, 280],
  privacyFirstName: [280, 310],
  privacyLastName: [310, 340],
  privacyMiddleInitial: [340, 341],
  legalReason: [341, 344],
  privacyEffDate: [344, 351, parseDate, makeDate],
  privacyThroughDate: [351, 358, parseDate, makeDate]
}

const parse = row => {
  row = row.toString('utf8').trim()
  if (row.length !== 359 || row[358] !== '*') {
    throw new Error(
      `Error in row. Row length: ${row.length}; last char: ${row[358]}`
    )
  }

  let mappedRow = {}
  for (let label in DEFAULT_MAP) {
    mappedRow[label] = row
      .substring(DEFAULT_MAP[label][0], DEFAULT_MAP[label][1])
      .trim()

    if (DEFAULT_MAP[label][2]) {
      if (typeof DEFAULT_MAP[label][2] === 'function') {
        mappedRow[label] = DEFAULT_MAP[label][2](mappedRow[label])
      }
    }
  }

  return mappedRow
}

/**
 *  Turn an object into an ELIG5 row format.
 *
 *  @param {Object} obj The object to be mapped to an ELIG5 row.
 *  @returns {String} The ELIG5 row.
 */
const stringify = obj => {
  let keys = Object.keys(DEFAULT_MAP)
  let str = ''
  keys.forEach(k => {
    let val = obj[k]
    if (val && typeof DEFAULT_MAP[k][2]) {
      if (typeof DEFAULT_MAP[k][2] === 'function') {
        val = DEFAULT_MAP[k][3](val)
      }
    }

    str += (val || '').padEnd(DEFAULT_MAP[k][1] - DEFAULT_MAP[k][0])
  })

  return str + '*'
}

module.exports = {
  parse,
  stringify,
  map: DEFAULT_MAP
}
